export default {
  getEmployeeContractTypes: (state) => state.employeeContractTypes,
  getEmployeeContractType: (state) => (id) => {
    return state.employeeContractTypes.find(employeeContractType => employeeContractType.id === id)
  },
}